import Swal from 'sweetalert2'

export function useSweetAlert() {
  /**
   * Show a success message
   */
  function showSuccess(title, message, options = {}) {
    return Swal.fire({
      icon: 'success',
      title: title || 'Success!',
      text: message,
      confirmButtonColor: '#1E40AF',
      ...options
    })
  }

  /**
   * Show an error message
   */
  function showError(title, message, options = {}) {
    return Swal.fire({
      icon: 'error',
      title: title || 'Error!',
      text: message,
      confirmButtonColor: '#1E40AF',
      ...options
    })
  }

  /**
   * Show a warning message
   */
  function showWarning(title, message, options = {}) {
    return Swal.fire({
      icon: 'warning',
      title: title || 'Warning!',
      text: message,
      confirmButtonColor: '#1E40AF',
      ...options
    })
  }

  /**
   * Show a confirmation dialog
   * Returns the full SweetAlert result object with isConfirmed property
   */
  function showConfirm(options = {}) {
    // Support both object parameter and legacy (title, message) parameters
    if (typeof options === 'string') {
      // Legacy usage: showConfirm(title, message, options)
      const title = arguments[0];
      const message = arguments[1];
      const opts = arguments[2] || {};
      return Swal.fire({
        icon: opts.icon || 'question',
        title: title || 'Are you sure?',
        text: message,
        showCancelButton: true,
        confirmButtonText: opts.confirmButtonText || 'Yes',
        cancelButtonText: opts.cancelButtonText || 'No',
        confirmButtonColor: '#1E40AF',
        cancelButtonColor: '#6b7280',
        ...opts
      });
    }

    // New usage: showConfirm({ title, text, confirmButtonText, ... })
    return Swal.fire({
      icon: options.icon || 'question',
      title: options.title || 'Are you sure?',
      text: options.text || options.message,
      showCancelButton: true,
      confirmButtonText: options.confirmButtonText || 'Yes',
      cancelButtonText: options.cancelButtonText || 'No',
      confirmButtonColor: '#1E40AF',
      cancelButtonColor: '#6b7280',
      ...options
    });
  }

  /**
   * Show a custom form
   */
  function showForm(title, html, options = {}) {
    return Swal.fire({
      title: title,
      html: html,
      showCancelButton: true,
      confirmButtonColor: '#1E40AF',
      ...options
    })
  }

  /**
   * Toast notification
   */
  function toast(message, icon = 'success', options = {}) {
    return Swal.fire({
      toast: true,
      position: options.position || 'top-end',
      icon: icon,
      title: message,
      showConfirmButton: false,
      timer: options.timer || 3000,
      timerProgressBar: true,
      ...options
    })
  }

  return {
    showSuccess,
    showError,
    showWarning,
    showConfirm,
    showForm,
    toast,
    swal: Swal
  }
}
